/**
 * @class
 */
import Base from '@netx/core/lib/netx-view';
import Template from '../templates/appModalCrumbsView.html';

import ChildViews from '@netx/core/functionality/childViews';

import ChildView from './appModalCrumbView';

class AppModalCrumbsView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.childView = {
			viewClass: ChildView,
			// Edge case: this is a view that happens to use a viewCollection to simply populate it's children and not
			// to inherit everything from them. Rather than try and accomplish this solution somehow in addChildView
			// I figured it best to be handled in the views that are utilizing a viewCollection differently than say
			// a netx-multiView would - since these options get applied last (superceed all others) we just put back the
			// values we do not want to inherit from a viewSpec
			options(model, opts) {
				return {
					tagName: 'li',
					model: model,
					collection: model.collection,
					attributes: {
						'data-nx-control': 'crumb',
					},
				};
			},
			...opts.childView,
		};
		opts.template = opts.template || Template;
		super(opts);
	}

	/** @override */
	bindCollectionEvents() {
		super.bindCollectionEvents();

		this.rendered.then(() => {
			this.listenTo(
				this.collection,
				'add remove reset',
				_.debounce(this.crumbsChanged, 25),
			);
		});

		return this;
	}

	/** @method */
	checkMultipleCrumbs() {
		this.el.classList.toggle('multiple-crumbs', this.collection.length > 1);
	}

	/** @method */
	crumbsChanged() {
		this.checkMultipleCrumbs();
	}

	/** @override */
	postRender() {
		super.postRender();

		this.checkMultipleCrumbs();
	}

	/**
	 * @static
	 * @type {string}
	 */
	static get __name__() {
		return 'AppModalCrumbsView';
	}
}

// Functionality
ChildViews(AppModalCrumbsView);

export default AppModalCrumbsView;
